import { render, staticRenderFns } from "./branchallcountList.vue?vue&type=template&id=4ae649b0&scoped=true&"
import script from "./branchallcountList.vue?vue&type=script&lang=js&"
export * from "./branchallcountList.vue?vue&type=script&lang=js&"
import style0 from "./branchallcountList.vue?vue&type=style&index=0&id=4ae649b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae649b0",
  null
  
)

export default component.exports